import { Swiper, Pagination, Autoplay, Thumbs, EffectFade } from 'swiper'

Swiper.use([Pagination, Autoplay, Thumbs, EffectFade])

const fn = {
  init: () => {
    document.querySelectorAll('.media-thumbnail-slider').forEach((el) => fn.setupSlider(el))
  },

  setupSlider: (el) => {
    const mainContainer = el.querySelector('.swiper-container.main-swiper')
    const thumbnailContainer = el.querySelector('.swiper-container.thumbnail-swiper')

    if (!mainContainer) {
      return
    }

    const numSlides = mainContainer.querySelectorAll('.swiper-slide').length

    const mainOpts = {
      autoplay: {
        delay: 4000,
      },
      slidesPerView: 1,
      speed: 500,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
    }

    const thumbnailOpts = {
      slidesPerView: 3,
      spaceBetween: 20,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    }

    if (numSlides > 3) {
      thumbnailOpts.pagination = {
        el: thumbnailContainer.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
      }
    }

    if (numSlides > 1) {
      const thumbnailSwiper = new Swiper(thumbnailContainer, thumbnailOpts)

      mainOpts.thumbs = {
        swiper: thumbnailSwiper,
      }

      new Swiper(mainContainer, mainOpts)
    }
  },
}

export default {
  can: () => true,
  run: fn.init,
}
